/*
 *   Copyright (c) 2021
 *   All rights reserved.
 */
export const ACTION_TYPES = {
    GET_UPCOMING_PROJECT: 'GET_UPCOMING_PROJECT',
    GET_DATA_REPORT: 'GET_DATA_REPORT',
};
